import { OUTCOME_COLORS, OUTCOME_LABELS, type Outcome } from '../types';

/**
 * The raw HighLevel `callStatus` values that the bucket label already says.
 * Anything else (busy, canceled, answered) is worth showing alongside it.
 */
const REDUNDANT_STATUSES = new Set(['completed', 'no-answer', 'voicemail', 'failed', 'pending', '']);

export function rawStatusDetail(outcome: Outcome, callStatus: string | null | undefined): string | null {
  const status = (callStatus ?? '').toLowerCase();
  if (REDUNDANT_STATUSES.has(status)) return null;
  if (status === OUTCOME_LABELS[outcome].toLowerCase()) return null;
  return callStatus ?? null;
}

/**
 * Outcome always ships as colour + label, never colour alone \u2014 the dot is the
 * identity cue beside the text, and the text carries the meaning.
 */
export function OutcomeTag({ outcome, detail }: { outcome: Outcome; detail?: string | null }) {
  return (
    <span className="tag" title={detail ?? undefined}>
      <span className="dot" style={{ background: OUTCOME_COLORS[outcome] }} aria-hidden="true" />
      {OUTCOME_LABELS[outcome]}
    </span>
  );
}
